import { Component } from 'react';
import { ErrorPage } from './ErrorPage';

export class Interceptor extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    // will intercept only errors occurs in render/return method of components
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}
